import React from "react";

class SocialLink extends React.Component {
  render() {
    return (
      <div className="social-link1">
        <ul>
          <li className="social-margin">
            <a
              target="_blank"
              href="https://www.facebook.com/pages/NicheSoft-Inc/327108187306802"
              onClick="_gaq.push(['_trackEvent', 'facebook', 'Click']);"
            >
              <img src="images/fb 1.png" />
            </a>
          </li>
          <li className="social-margin">
            <a
              target="_blank"
              href="https://www.linkedin.com/company/2748592?trk=prof-exp-company-name"
              onClick="_gaq.push(['_trackEvent', 'LinkedIn', 'Click']);"
            >
              <img src="images/linkedin.png" />
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default SocialLink;



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/social_link.js